export const Colors = [
  { textColor: '#072D4A', bgColor: '#D8EEFF' },
  { textColor: '#3A2C00', bgColor: '#FFF6D8' },
  { textColor: '#D66F06', bgColor: '#FFECCC' },
  { textColor: '#4C037B', bgColor: '#F6EBFF' },
  { textColor: '#008F5D', bgColor: '#E4F9F0' },
]
